import { useMutation, useQueryClient } from "@tanstack/react-query";
import { 
  createInventoryMedia, 
  deleteInventoryMedia,
} from "../api.js";
import { useNotification } from "../../../contexts/NotificationContext";


export const useCreateMedia = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  
  return useMutation({
    mutationFn: ({ data, files }) => createInventoryMedia(data, files),
    onSuccess: (data) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: ["media-files"] });
      queryClient.invalidateQueries({ queryKey: ["media-files-by-inventory"] });
      queryClient.invalidateQueries({ queryKey: ["inventory-detail"] });
      queryClient.invalidateQueries({ queryKey: ["deal"] });
      queryClient.invalidateQueries({ queryKey: ["calculus-detail"] });
      queryClient.invalidateQueries({ queryKey: ["customer-detail"] });
      queryClient.invalidateQueries({ queryKey: ["channel"] });
      
      // Show success notification
      showNotification('success', 'Files uploaded successfully!');
    },
    onError: (error) => {
      console.error("Error creating inventory media:", error);
      let errorMessage = 'Error creating inventory media. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      showNotification('danger', errorMessage);
    },
  });
};

export const useDeleteMedia = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  
  return useMutation({
    mutationFn: ({ id }) => deleteInventoryMedia(id),
    onSuccess: (data) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: ["media-files"] });
      queryClient.invalidateQueries({ queryKey: ["media-files-by-inventory"] });
      queryClient.invalidateQueries({ queryKey: ["inventory-detail"] });
      queryClient.invalidateQueries({ queryKey: ["deal"] });
      queryClient.invalidateQueries({ queryKey: ["calculus-detail"] });
      queryClient.invalidateQueries({ queryKey: ["customer-detail"] });
      queryClient.invalidateQueries({ queryKey: ["channel"] });
      // Show success notification
      showNotification('success', 'File deleted successfully!');
    },
    onError: (error) => {
      console.error("Error deleting inventory media:", error);
      showNotification('danger', 'Error deleting image. Please try again.');
    },
  });
}; 